import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function defineOneSensorId() {
    return (
        <Whisper
            placement="right"
            trigger="hover"
            speaker={
                <Tooltip>
                    <FormattedMessage id="history.defineOneSensorId" />
                </Tooltip>
            }>
            <FontAwesomeIcon icon={faExchangeAlt} size="lg" style={{ color: 'orange' }} />
        </Whisper>
    );
}
